import ProjectDefaultProperties from "../default/default-properties"
import projectProperties_toJSON from "../functions/properties-to-json"
import {ProjectAvailableMenuOptions} from "../project-properties"
import ProjectSession from "../../project-session"
import {ProjectPropertiesData} from "../../types"

const DEFAULT = {
    canCreateTask           : false,
    canCreateProject        : true,
    // canCreatePage           : false,
    canCreateLink           : true,
    canCreateEmbed          : true,
    canCreateMeeting        : false,
    canCreateEvent          : false,
    canCreateDiscussion     : false,
    canCreateDocument       : false,
    canCreateGoal           : false,
    canCreateDashboard      : false,
    canCreateRequestForms   : false,
    canCreateAttachments    : false,

}

export default class ProjectEmbedProperties extends ProjectDefaultProperties {

    constructor(properties:any, project: ProjectSession) {
        super(properties, project)

        this.canCreateTask                          = DEFAULT.canCreateTask
        this.canCreateProject                       = DEFAULT.canCreateProject
        // this.canCreatePage                          = DEFAULT.canCreatePage
        this.canCreateLink                          = DEFAULT.canCreateLink
        this.canCreateEmbed                         = DEFAULT.canCreateEmbed
        this.canCreateMeeting                       = DEFAULT.canCreateMeeting
        this.canCreateEvent                         = DEFAULT.canCreateEvent
        this.canCreateDiscussion                    = DEFAULT.canCreateDiscussion
        this.canCreateDocument                      = DEFAULT.canCreateDocument
        this.canCreateGoal                          = DEFAULT.canCreateGoal
        this.canCreateDashboard                     = DEFAULT.canCreateDashboard
        this.canCreateRequestForms                  = DEFAULT.canCreateRequestForms
        this.canCreateAttachments                   = DEFAULT.canCreateAttachments
        this.canHaveStatus                          = false

        this.menuSections.reports                   = false
        this.menuSections.integrations              = false
        this.menuSections.automations               = false

        this.settingsSections.workItems             = false
        this.settingsSections.taskTypes             = false
        this.settingsSections.customFields          = false
        this.settingsSections.views                 = false
        this.settingsSections.taskId                = false
        this.settingsSections.navigation            = false
        this.settingsSections.tasksWorkflowBlock    = false
    }

    get availableMenuOptions(): ProjectAvailableMenuOptions {
        return {
            pinStar         : true,
            info            : true,
            users           : true,
            settings        : false,
            status          : false,
            history         : true,
            rename          : true,
            editSource      : true,
            colorIcon       : true,
            move            : true,
            convert         : true,
            duplicate       : true,
            saveAsTemplate  : true,
            delete          : true,
            archive         : true,
            directLink      : true,
            showInMenu      : true,
        }
    }

    toJSON(): ProjectPropertiesData {
        return projectProperties_toJSON(this, DEFAULT)
    }
}
